import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { IdType } from "common/types";
import { RECEIVE_STATS, RECEIVE_VALIDATIONS } from "common/reducers/validation.actions";
import { currentOrgId } from "common/selectors/org.selectors";
import { ValidationUploadStatsRecord, validationUploadStatsFromJSON } from "common/records/ValidationUploadStats";
import { ValidationRecord, validationFromJSON, IValidationData } from "common/records/Validation";

export const ValidationStateRecord = Record({
  uploadStatsByOrgId: Map<IdType, ValidationUploadStatsRecord>(),
  byId: Map<number, ValidationRecord>(),
  byItemUuid: Map<string, number>(),
});

export const initialState = ValidationStateRecord();
export type ValidationState = typeof initialState;

const model = "validations";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_STATS:
      state = state.setIn(
        [model, "uploadStatsByOrgId", currentOrgId(state)],
        validationUploadStatsFromJSON(action.payload.stats),
      );
      return state;

    case RECEIVE_VALIDATIONS: {
      const validations: IValidationData[] = action.payload.validations;
      let byId = Map<number, ValidationRecord>();
      let byItemUuid = Map<string, number>();

      validations.forEach((v) => {
        byId = byId.set(v.id, validationFromJSON(v));
        byItemUuid = byItemUuid.set(`${v.kind}-${v.item_uuid}`, v.id);
      });

      state = state.setIn([model, "byId"], byId);
      state = state.setIn([model, "byItemUuid"], byItemUuid);
      return state;
    }

    default:
      return state;
  }
};
